// extracted by mini-css-extract-plugin
export var contactLink = "emso-Footer-module__contactLink";
export var contactWrapper = "emso-Footer-module__contactWrapper";
export var footer = "emso-Footer-module__footer emso-Layout-module__row";
export var footerDisclaimer = "emso-Footer-module__footerDisclaimer";
export var footerLinks = "emso-Footer-module__footerLinks";
export var footerLogo = "emso-Footer-module__footerLogo";
export var footerWrapper = "emso-Footer-module__footerWrapper";
export var getInTouch = "emso-Footer-module__getInTouch";
export var links = "emso-Footer-module__links";